import application from 'application/application';

import moment from 'moment';

const controller = 'PublicationsListController';

application

	.controller(controller, [
		'$scope',
		'$rootScope',
		'$http',
		'$state',
		'$stateParams',
		'API',
		'helper',
		'ngNotify',
		'permissions',
		'downloadService',
		(
			$scope,
			$rootScope,
			$http,
			$state,
			$stateParams,
			API,
			helper,
			ngNotify,
			permissions,
			downloadService
		) => {
			const featurePermissions = {
				agenda: permissions.get('schedule'),
				processes: permissions.get('processes'),
				publications: permissions.get('publications'),
				subpoena: permissions.get('subpoena')
			};

			const blocked = localStorage.getItem('__authenticationUserBlocked__');

			$scope.groupUserData = JSON.parse(
				localStorage.getItem('__groupUserData__')
			);
			$scope.groupSelected = JSON.parse(
				localStorage.getItem('__groupSelected__')
			);

			$scope.hasGroup = JSON.parse(localStorage.getItem('__hasGroup__'));

			$scope.focus = false;

			$scope.lastSearched = 0;

			$scope.lastEmptySearch = null;

			featurePermissions.processes.update().then(() => {
				if (blocked == 'true') return $state.go('root.default.blockedUser');

				if (
					!featurePermissions.processes.has('createMovements') ||
					!featurePermissions.publications.has('recordPublications')
				) {
					if (
						!featurePermissions.publications.has('recordPublications') &&
						featurePermissions.subpoena.has('createSubpoena')
					) {
						return $state.go('root.default.subpoena');
					} else {
						return $state.go('root.default.publications');
					}
				}
			});

			$scope.placeholderDate = new Date().toLocaleString('pt-BR');

			$scope.getScopedInputValue = scopedInput =>
				scopedInput && scopedInput.$viewValue;

			$scope.modalKey = helper.responseStore();

			$scope.stateParams = $.extend({}, $stateParams);

			$scope.hasStateParams =
				$stateParams.palavraChave ||
				$stateParams.lido ||
				$stateParams.diary ||
				$stateParams.note ||
				$stateParams.dataInicio ||
				$stateParams.dataFim;

			$scope.selectAll = false;
			$scope.clearAll = false;
			$scope.keywordsList = [];
			$scope.hasMoreItems = false;
			$scope.diariesSelected = [];

			$scope.pagination = {
				paginaAtual: 0,
				totalItens: 0,
				quantiaPorPagina: 0,
				hasNext: false,
				// eslint-disable-next-line space-before-function-paren
				getInfo: function(checked, model, main = false) {
					let inicial = (this.paginaAtual - 1) * this.quantiaPorPagina + 1,
						final =
							(this.paginaAtual - 1) * this.quantiaPorPagina +
							this.quantiaPorPagina;

					if (inicial == 0) inicial = 1;

					if (final > this.totalItens) final = this.totalItens;

					if (this.totalItens == final) this.hasNext = false;
					else this.hasNext = true;

					// return '<b>Exibindo ' + inicial + ' - ' + final + '</b> de ' + this.totalItens + ' movimentações';
					$scope.clearAll = false;
					if (model) {
						if (main) {
							$scope.selectAll = true;
							$('.custom-control.custom-checkbox input[type=checkbox]').prop(
								'checked',
								true
							);
							$scope.checkedElements = $scope.quantityPerPage;
						} else {
							$scope.selectAll = true;

							if ($scope.checkedElements || $scope.checkedElements == 0)
								$scope.checkedElements = $scope.checkedElements + 1;
							else
								$scope.checkedElements =
									checked == 0 ? $scope.quantityPerPage : checked;
						}
					} else {
						$scope.selectAll = false;
					}
				}
			};

			$scope.selectAllToggle = toggle => {
				$scope.clearAll = !toggle;
				$scope.selectAll = false;

				if (toggle) {
					$scope.checkedElements = 0;
					$('.custom-control.custom-checkbox input[type=checkbox]').prop(
						'checked',
						false
					);
					$scope.publications.setUncheckedItems();
				}
			};

			$scope.variations = [];
			$scope.keyWordsVariations = helper.responseStore().setItemsPerPage(1);

			$scope.searchKeyList = {};

			$scope.getSearchKeyForSearch = (palavraChave, idPalavraChave) => {
				const selectSearchKey = palavraChave.find(
					item => item.id === idPalavraChave
				);

				idPalavraChave = Number(idPalavraChave);

				let paramsSearch = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 10,
					paginaAtual: $scope.page || 1,
					idPalavraChave: idPalavraChave
				};

				if (selectSearchKey === undefined)
					$http({
						...helper.http(API.keyWordsClient, 'GET'),
						params: paramsSearch
					}).then(({ data: { itens } }) => {
						if (itens[0]) {
							$scope.filter.nomePalavraChave = itens[0].palavraChave;
							$scope.nomePalavraChavePesquisa = itens[0].palavraChave;
							$scope.filter.palavraChave = itens[0].id;
						}
					});
				else {
					$scope.filter.nomePalavraChave = selectSearchKey.palavraChave;
					$scope.nomePalavraChavePesquisa = selectSearchKey.palavraChave;
					$scope.filter.palavraChave = selectSearchKey.id;
				}
			};

			/**
			 * Funções dos filtros palavra-chave
			 */

			$scope.getDiariesKeyWords = idPalavraChave => {
				const params = {
					IdsPalavraChave: idPalavraChave
				};

				$http({
					...helper.http(API.diariesKeyWords, 'GET'),
					params
				}).then(({ data: { itens } }) => {
					$scope.diariesSelected = itens;
				});
			};

			$scope.handlerChangeFilterSearchKey = idPalavraChave => {
				$scope.focus = false;

				$('#status').trigger('focus');

				$scope.getSearchKeyForSearch(
					$scope.modalKey.getItems(),
					idPalavraChave
				);
				// $('.modal').modal('hide');
				// $('.modal-backdrop').addClass('d-none');
				$scope.getDiariesKeyWords(idPalavraChave);
			};

			if ($stateParams.palavraChave !== undefined)
				$scope.handlerChangeFilterSearchKey($stateParams.palavraChave);

			$scope.filtersSearchKey = (items, event) => {
				if (event) event.preventDefault();

				$scope.page = 1;

				$scope.filter = items;

				let paramsSearch = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 10,
					paginaAtual: $scope.page || 1
				};

				// if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				// 	paramsSearch.IdGrupoUsuariosDono = $scope.groupUserData.idGrupo;
				// }

				if (items.nomePalavraChave)
					paramsSearch.nomePalavraChave = items.nomePalavraChave;

				$http({
					...helper.http(API.keyWordsClient, 'GET'),
					params: paramsSearch
				})
					.then(({ data: { itens } }) => {
						if (itens[0]) {
							items.nomePalavraChave != undefined
								? $scope.modalKey.setItems(
										itens.filter(item => {
											return item.palavraChave
												.toUpperCase()
												.includes(items.nomePalavraChave.toUpperCase());
										})
								  )
								: $scope.modalKey.setItems(itens);

							if (itens.length === 1) {
								$scope.filter.nomePalavraChave = itens[0].palavraChave;
								$scope.filter.palavraChave = itens[0].id;
								$('#modalPalChave').modal('hide');
							} else {
								$('#modalPalChave').modal('show');
							}
						} else {
							$('#modalPalChave').modal('show');
						}
					})

					.finally(() => $scope.modalKey.setReady(true));
			};

			$scope.shouldSkipEmptySearch = function(current) {
				if (!$scope.lastEmptySearch) return false;
				if (!current) return false;

				var base = ($scope.lastEmptySearch || '').toLowerCase();
				var atual = (current || '').toLowerCase();

				if (atual.length <= base.length) {
					return false;
				}

				var containsBase = atual.indexOf(base) !== -1;

				return containsBase;
			};

			$scope.onChangeKeyword = function(nome) {
				if (!nome) {
					$scope.keywordsList = [];
					$scope.lastEmptySearch = null;

					return;
				}

				if ($scope.shouldSkipEmptySearch(nome)) {
					return;
				}

				$scope.getKeywordByName(nome, 1);
			};

			$scope.getKeywordByName = (nome = '', page = 1) => {
				if (page === 1) {
					$scope.keywordsList = [];
				}

				$scope.lastSearched = page;
				$scope.isLoadingKeywords = true;

				let paramsSearch = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					NomePalavraChave: nome,
					registrosPorPagina: 20,
					paginaAtual: page
				};

				$http({
					...helper.http(API.keyWordsClient, 'GET'),
					params: paramsSearch
				})
					.then(({ data: { itens, paginacao } }) => {
						const { paginaAtual } = paginacao;

						$scope.hasMoreItems = itens.length && itens.length === 20;

						if (paginaAtual > 1) {
							$scope.keywordsList.push(...itens);
						} else {
							$scope.keywordsList = itens;
						}

						if (page === 1) {
							if (!itens || itens.length === 0) {
								$scope.lastEmptySearch = nome;
							} else {
								$scope.lastEmptySearch = null;
							}
						}
					})
					.finally(() => {
						$scope.isLoadingKeywords = false;
					});
			};

			$scope.getKeywordByName();

			$scope.loadMoreKeywords = event => {
				event.stopPropagation();

				$scope.getKeywordByName(
					$scope.filter.nomePalavraChave,
					$scope.lastSearched + 1
				);
			};

			$scope.page = 1;

			/** Verifica se existe uma página anterior à atual. */
			$scope.modalHasSearchKeyPrevPage = () =>
				$scope.page == 1 ? false : true;

			/** Navega para a primeira página. */
			$scope.modalRecordSearchKeyFirstPage = filter => {
				$scope.page = 1;

				let params = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 10,
					paginaAtual: $scope.page || 1
				};

				// if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				// 	params.IdGrupoUsuariosDono = $scope.groupUserData.idGrupo;
				// }

				$http({
					...helper.http(API.keyWordsClient, 'GET'),
					params: params
				})
					.then(({ data: { itens } }) => {
						filter.nomePalavraChave != undefined
							? $scope.modalKey.setItems(
									itens.filter(item => {
										return item.palavraChave
											.toUpperCase()
											.includes(filter.nomePalavraChave.toUpperCase());
									})
							  )
							: $scope.modalKey.setItems(itens);
					})

					.finally(() => $scope.modalKey.setReady(true));
			};

			/** Navega para a página anterior. */
			$scope.modalRecordSearchKeyPrevPage = filter => {
				$scope.page = $scope.page - 1;

				let params = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 10,
					paginaAtual: $scope.page || 1
				};

				// if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				// 	params.IdGrupoUsuariosDono = $scope.groupUserData.idGrupo;
				// }

				$http({
					...helper.http(API.keyWordsClient, 'GET'),
					params: params
				})
					.then(({ data: { itens } }) => {
						filter.nomePalavraChave != undefined
							? $scope.modalKey.setItems(
									itens.filter(item => {
										return item.palavraChave
											.toUpperCase()
											.includes(filter.nomePalavraChave.toUpperCase());
									})
							  )
							: $scope.modalKey.setItems(itens);
					})

					.finally(() => $scope.modalKey.setReady(true));
			};

			/** Navega para a próxima página. */
			$scope.modalRecordSearchKeyNextPage = filter => {
				$scope.page = $scope.page + 1;

				let params = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 10,
					paginaAtual: $scope.page || 1
				};

				// if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				// 	params.IdGrupoUsuariosDono = $scope.groupUserData.idGrupo;
				// }

				$http({
					...helper.http(API.keyWordsClient, 'GET'),
					params: params
				})
					.then(({ data: { itens } }) => {
						filter.nomePalavraChave != undefined
							? $scope.modalKey.setItems(
									itens.filter(item => {
										return item.palavraChave
											.toUpperCase()
											.includes(filter.nomePalavraChave.toUpperCase());
									})
							  )
							: $scope.modalKey.setItems(itens);
					})

					.finally(() => $scope.modalKey.setReady(true));
			};

			/** Instância de armazenamento de resposta. */
			$scope.keyWordsMovements = helper
				.responseStore()

				.setItemsPerPage(5);

			/**
			 * Recupera processos.
			 *
			 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
			 *
			 * @example
			 * // Cria uma instância de armazenamento de resposta.
			 * $scope.keyWordsMovements = helper.responseStore();
			 *
			 * // Recupera as aplicações.
			 * $scope.recordKeyWordsMovements($scope.keyWordsMovements);
			 */
			$scope.recordKeyWordsMovements = responseStore => {
				let params = {
					registrosPorPagina: 20,
					idTipoPasta: '-2',
					campos: '*',
					ativo: true
				};

				// if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				// 	params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
				// }

				$http({
					...helper.http(API.briefcase, 'GET'),
					params
				})
					.then(response => {
						responseStore.setItems(response.data.itens);

						$.extend($rootScope.pagination, {
							totalItens: response.data.itens.quantidadeTotal
						});
					})

					.finally(() => responseStore.setReady(true));
			};

			$scope.clientUserKeywords = helper.responseStore();

			/** Instância de armazenamento de resposta. */
			$scope.movements = helper
				.responseStore()

				.setItemsPerPage(10);

			/** Define a página atual com base na URL. */
			if ($stateParams.paginaAtual !== undefined)
				$scope.movements.setCurrentPage($stateParams.paginaAtual);

			$scope.filter = $.extend({}, $stateParams);

			$scope.filterMovements = filters => {
				$state.go($state.current.name, filters);
			};

			/** Instância de armazenamento de resposta. */
			$scope.publications = helper
				.responseStore()
				.setItemsPerPage(10)
				.setCurrentPage($stateParams.paginaAtual);

			/* Filtros */
			let filtersKeywordsMainsFiltersNames = [
				'palavraChave',
				'lido',
				'dataInicio',
				'dataFim',
				'diary'
			];

			/** Percorre os filtros */
			filtersKeywordsMainsFiltersNames.forEach(name => {
				let value = $stateParams[name];

				if (value !== undefined) $scope.publications.setFilter(name, value);
			});

			$scope.clearFiltersKeywordsMainsFilters = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = 1;

				filtersKeywordsMainsFiltersNames.forEach(name => delete params[name]);

				$state.go($state.current.name, params, { inherit: false });
			};

			$scope.removeFiltersKeywordsMainsFilter = (filter, event) => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = 1;

				delete params[filter];

				if (!event) $state.go($state.current.name, params, { inherit: false });
			};

			$scope.clearFilterSelected = arr => {
				let params = helper.cloneSimpleObject($stateParams);

				arr.map(item => delete params[item]);

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Recupera publicações.
			 *
			 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
			 *
			 * @example
			 * // Cria uma instância de armazenamento de resposta.
			 * $scope.publications = helper.responseStore();
			 *
			 * // Recupera as aplicações.
			 * $scope.recordPublications($scope.publications);
			 */

			$scope.recordPublications = responseStore => {
				let { paginaAtual = 1 } = $stateParams;

				let today = new Date();

				let pastDay, fixStartDate, fixEndDate;

				pastDay = moment(moment(today).add(-30, 'days')).format('Y-MM-DD');

				if ($stateParams.dataInicio) {
					fixStartDate = `${$stateParams.dataInicio.substr(
						6
					)}-${$stateParams.dataInicio.substr(
						3,
						2
					)}-${$stateParams.dataInicio.substr(0, 2)}`;
					$scope.filter.dataInicio = moment(fixStartDate).format('DD/MM/Y');
				} else $scope.filter.dataInicio = moment(pastDay).format('DD/MM/Y');

				if ($stateParams.dataFim) {
					fixEndDate = `${$stateParams.dataFim.substr(
						6
					)}-${$stateParams.dataFim.substr(3, 2)}-${$stateParams.dataFim.substr(
						0,
						2
					)}`;
					$scope.filter.dataFim = moment(fixEndDate).format('DD/MM/Y');
				} else $scope.filter.dataFim = moment(today).format('DD/MM/Y');

				const paramsSearch = {
					...helper.httpFields([
						'cidadeComarcaDescricao, dataPublicacao, descricaoCadernoDiario, id, idUsuarioCliente, lido, nomeCadernoDiario, nomeDiario, numero, idTipoPalavraChave,palavraChave,idPublicacaoCliente,idPalavraChave,numeroProcesso,numeroCNJ'
					]),
					ordenacao: '-dataPublicacao',
					Ativo: true,
					DataFimMovimento: $stateParams.dataFim
						? fixEndDate
						: moment(today).format('Y-MM-DD'),
					DataInicioMovimento: $stateParams.dataInicio ? fixStartDate : pastDay,
					registrosPorPagina: $scope.quantityPerPage,
					paginaAtual: paginaAtual
				};

				if ($stateParams.palavraChave) {
					paramsSearch.idsPalavrasChaves = $stateParams.palavraChave;
					$scope.handlerChangeFilterSearchKey($stateParams.palavraChave);
				}

				if ($stateParams.lido) paramsSearch.lido = $stateParams.lido;

				if ($stateParams.diary) paramsSearch.idsDiarios = $stateParams.diary;

				let quantityPerPage;

				if ($stateParams.note)
					paramsSearch.idsCadernosDiarios = $stateParams.note;

				quantityPerPage = paramsSearch.registrosPorPagina;

				if ($scope.hasStateParams) {
					if ($scope.hasGroup && $scope.groupSelected) {
						paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
					}

					$http({
						...helper.http(API.publications, 'pagination'),
						params: paramsSearch
					})
						.then(response => {
							responseStore.setItems(response.data.itens);

							if (response.data.paginacao) {
								$scope.publicationsLength = response.data.paginacao
									? response.data.paginacao.registrosTotal
									: 0;

								$scope.publicationsPagesLength = Math.ceil(
									$scope.publicationsLength / quantityPerPage
								);

								$.extend($scope.pagination, {
									paginaAtual: responseStore.getCurrentPage(),
									quantiaPorPagina:
										response.data.itens.length > quantityPerPage
											? quantityPerPage
											: response.data.itens.length,
									hasNext:
										response.data.paginacao.paginaAtual <
										$scope.publicationsPagesLength,
									totalItens: response.data.paginacao
										? response.data.paginacao.registrosTotal
										: 0
								});
							}
						})

						.finally(() => responseStore.setReady(true));
				} else {
					responseStore.setReady(true);
				}
			};

			// $scope.recordPublications($scope.publications);

			$scope.recordKeyWordsMovements($scope.keyWordsMovements);

			/** Instância de armazenamento de resposta. */
			$scope.quantitiesItem = [
				{
					quantity: 10
				},
				{
					quantity: 20
				},
				{
					quantity: 50
				},
				{
					quantity: 100
				}
			];

			/**
			 Recupera todos os diários da palavra-chave, tanto inativos/ativos.
		 */
			$scope.recordClientUserDiaries = () => {
				$scope.clientUserKeywords.setReady(false);

				let params = {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					registrosPorPagina: 999999,
					paginaAtual: 1
				};

				if ($scope.hasGroup && $scope.groupSelected) {
					params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
				}

				$http({
					...helper.http(API.searchPublicationUserClient, 'GET'),
					params
				})
					.then(({ data: { itens } }) => {
						let keywords = [];

						itens.map(k =>
							keywords.length === 0
								? keywords.push(k)
								: !keywords.some(y => y.idPalavraChave === k.idPalavraChave)
								? keywords.push(k)
								: ''
						);

						$scope.clientUserKeywords.setItems(keywords);
					})
					.finally(() => $scope.clientUserKeywords.setReady(true));
			};

			//$scope.recordClientUserDiaries();

			$scope.setReadUnread = (movement, filter, nameCallButton) => {
				let item = {
					id: movement.id,
					idMovProcessoCliente: movement.palavrasChave[0].idPublicacaoCliente,
					idUsuarioMovimento: filter.usuarioCliente
				};

				if ($scope.hasGroup && $scope.groupSelected) {
					item.idGrupoUsuarios = $scope.groupUserData.idGrupo;
				}

				let actionToSet =
					nameCallButton == 'view'
						? 'setAsRead'
						: movement.lido
						? 'setAsUnread'
						: 'setAsRead';

				$http({
					...helper.http(API.publications, actionToSet),
					method: 'PUT',
					data: {
						itens: [item]
					},
					messageOverride: {
						success() {}
					}
				}).then(response => {
					if (
						(!movement.lido || actionToSet == 'setAsUnread') &&
						response &&
						response.data &&
						response.data.status &&
						response.data.status.mensagem
					) {
						ngNotify.set(response.data.status.mensagem, {
							type: 'success',
							position: 'bottom'
						});
					}

					movement.lido = !movement.lido;

					const params = {
						id: movement.id,
						idUsuarioCliente: movement.idUsuarioCliente
					};

					if (nameCallButton == 'view')
						$state.go('root.default.publications.publicationsDetails', params, {
							inherit: true
						});
				});
			};

			/**
			 * Verifica se existe uma página anterior à atual.
			 */
			$scope.hasMovementsPrevPage = () =>
				($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

			/**
			 * Navega para a primeira página.
			 */
			$scope.recordMovementsFirstPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = 1;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a ultima página.
			 */
			$scope.recordMovementsLastPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = $scope.publicationsPagesLength;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a página anterior.
			 */
			$scope.recordMovementsPrevPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				let currentPage = params.paginaAtual ? Number(params.paginaAtual) : 1;

				params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a próxima página.
			 */
			$scope.recordMovementsNextPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = params.paginaAtual
					? Number(params.paginaAtual) + 1
					: 2;

				$state.go($state.current.name, params, { inherit: false });
			};

			$scope.closeModal = id => $(`#${id}`).modal('hide');

			$scope.reload = () => {
				location.reload();
			};

			$scope.openModalDownload = (movement, all = false) => {
				let el;

				$scope.movementInAction = movement;

				if (all) {
					$scope.selectAll = true;
				}

				el = $('#modalDownload');

				el.modal && el.modal('show');
			};

			$scope.openModalEmail = movement => {
				$scope.movementInAction = null;

				$scope.movementInAction = movement;

				const el = $('#modalSendEmail');

				el.modal && el.modal('show');
			};

			/* Integração de Downloads */

			$scope.downloadMovements = (fileType = 'pdf') => {
				const movement = $scope.movementInAction;
				const checkedItems = $scope.publications.getCheckedItems();

				if (!movement && !checkedItems.length)
					return ngNotify.set('Nenhum movimento selecionado.', {
						type: 'error',
						position: 'bottom'
					});

				const ids = movement
					? movement.movimento.id.toString()
					: checkedItems.map(x => x.id).join();

				/**
				 *  Talvez não seja necessario alterar aqui a requisição por grupo,
				 *  pelo que parece é solicitado o download apenas dos itens selecionados,
				 *  que no caso já sera filtrado na tela por grupo nas outras requisições.
				 *  (Quando listado as publicações)
				 *
				 * 	if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				 *  	params.idGrupoMovimento = $scope.groupUserData.idGrupo;
				 *  }
				 */

				const params = {
					ids,
					tipoArquivo: fileType
				};

				if ($scope.hasGroup && $scope.groupSelected) {
					params.idGrupoMovimento = $scope.groupUserData.idGrupo;
				} else {
					params.idUsuarioMovimento = JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente;
				}

				const rota = 'movements';

				downloadService.serviceDownload(params, rota, movement, checkedItems);

				$scope.clearAll = false;
				$scope.selectAll = false;
			};
			/* Integração de Envio de E-mail */

			$scope.sendMovementsEmail = email => {
				const movement = $scope.movementInAction;
				const checkedItems = $scope.publications.getCheckedItems();

				let emails = email.split(';');

				const tipo = movement ? movement.movimento.idTipoMovProcesso : null;

				if (!movement && !checkedItems.length)
					return ngNotify.set('Nenhum movimento selecionado.', {
						type: 'error',
						position: 'bottom'
					});

				const ids = movement
					? movement.movimento.id.toString()
					: checkedItems.map(x => x.id).join();
				let checked = $scope.publications.getCheckedItems().length;

				let mensagemSucesso =
					checked > 1
						? 'Movimentações enviadas por email!'
						: 'Movimentação enviada por email!';
				let mensagemErro =
					checked > 1
						? 'Erro ao enviar movimentações por email!'
						: 'Erro ao enviar movimentação por email!';

				if (tipo) {
					if (tipo == -1) {
						mensagemSucesso = 'Andamento enviado por email!';
					} else if (tipo == -2) {
						mensagemSucesso = 'Publicação enviada por email!';
					}
				}

				let params = {
					idsMovimentos: ids,
					destinatarios: emails
				};

				if ($scope.hasGroup && $scope.groupSelected)
					params.idGrupoMovimento = $scope.groupUserData.idGrupo;
				else
					params.idUsuarioMovimento = JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente;

				$http({
					...helper.http(API.email, 'movements'),
					method: 'POST',
					data: params,
					messageOverride: {
						success() {
							ngNotify.set(mensagemSucesso, {
								type: 'success',
								position: 'bottom'
							});
						},
						error(response) {
							if (response.data.status.erros.length)
								ngNotify.set(response.data.status.erros[0].mensagem, {
									type: 'error',
									position: 'bottom'
								});
							else
								ngNotify.set(mensagemErro, {
									type: 'error',
									position: 'bottom'
								});
						}
					}
				}).finally(() => {
					$scope.clearAll = false;
					$scope.selectAll = false;

					$scope.email = '';

					$scope.$resetFormValidation('sendEmail')();

					$('#modalSendEmail').modal('hide');

					checkedItems.forEach(movement => (movement.__checked__ = false));
				});
			};

			$scope.returnTooltip = (processes, number) => {
				let processesTooltip = number ? number + '\n' : '';

				processes
					.filter(
						process =>
							process.numeroProcesso.replace(/[^0-9]/g, '') !=
							number.replace(/[^0-9]/g, '')
					)
					.map((process, index) => {
						processesTooltip += process.numeroProcesso.replace(
							/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
							'$1-$2.$3.$4.$5.$6'
						);

						processesTooltip += index < processes.length - 1 ? '\n' : '';
					});

				return processesTooltip;
			};
			/* GET de quantidade de itens por pagina */

			$scope.recordItemsPerPageQuantity = () => {
				$http({
					...helper.http(API.parametersUsers, 'GET'),
					params: {
						...helper.httpFields(['*'])
					},
					messageOverride: {
						success() {}
					}
				})
					.then(response => {
						if (response.data.itens) {
							$scope.quantityPerPage =
								response.data.itens[0].qtdRegistroMovPorPagina;
							$scope.idQtdItensPagina =
								response.data.itens[0].idParamUsuarioProdAdv;
						} else $scope.quantityPerPage = 20;
					})

					.finally(() => $scope.recordPublications($scope.publications));
			};

			$scope.recordItemsPerPageQuantity();

			$scope.updateQuantityPerPage = quantityPerPage => {
				if ($scope.idQtdItensPagina) {
					$http({
						...helper.http(API.parametersUsers),
						method: 'PUT',
						data: {
							itens: [
								{
									id: $scope.idQtdItensPagina,
									qtdRegistroMovPorPagina: quantityPerPage || 20
								}
							]
						},
						messageOverride: {
							success() {}
						}
					}).then(() => {
						$state.go(
							$state.current.name,
							{
								paginaAtual: 1,
								palavraChave: $stateParams.palavraChave,
								cliente: $stateParams.cliente,
								usuarioCliente: $stateParams.usuarioCliente,
								dataInicio: $stateParams.dataInicio,
								dataFim: $stateParams.dataFim,
								diary: $stateParams.diary,
								lido: $stateParams.lido
							},
							{ inherit: false, reload: 'root.default.publications' }
						);
					});
				} else {
					$http({
						...helper.http(API.parametersUsers),
						method: 'POST',
						data: {
							itens: [
								{
									qtdRegistroMovPorPagina: quantityPerPage || 20
								}
							]
						},
						messageOverride: {
							success() {}
						}
					}).then(() => {
						$state.go(
							$state.current.name,
							{
								paginaAtual: 1,
								palavraChave: $stateParams.palavraChave,
								cliente: $stateParams.cliente,
								usuarioCliente: $stateParams.usuarioCliente,
								dataInicio: $stateParams.dataInicio,
								dataFim: $stateParams.dataFim,
								diary: $stateParams.diary,
								lido: $stateParams.lido
							},
							{ inherit: false, reload: 'root.default.publications' }
						);
					});
				}
			};
		}
	])

	.filter('capitalize', () => {
		return capitalize;
	});

const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
const REGEX_FIRST = /([^\W_]+[^\s-]*)/;

const capitalize = (input, all) => {
	if (!input) return '';

	const regex = all ? REGEX_ALL : REGEX_FIRST;

	return input.replace(
		regex,
		txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	);
};

export default controller;
